(function () {
    'use strict';

    angular
        .module('generalReports')
        .controller('GeneralReportsClientHistoryController', GeneralReportsClientHistoryController);
    GeneralReportsClientHistoryController.$inject = ['$scope','$uibModal', 'PhysicalFairService','GeneralReportsService'];
    function GeneralReportsClientHistoryController($scope,$uibModal, PhysicalFairService, GeneralReportsService) {
        var vm = this;

        vm.flag                  = false;
        vm.clientHistoryResult   = [];
        vm.exhibitorSelected     = [];
        vm.i                     = -1;
        //vm.selectExhibitors      = selectExhibitors;
        // vm.getByFilter           = getByFilter;
        vm.getExhibitors         = getExhibitors;
        vm.exhibitorSelectedCSV  = '';
        vm.client                = '';

        vm.getInvoices                  = getInvoices;
        vm.getPhysicalFairs             = getPhysicalFairs;
        vm.getVirtualFairs              = getVirtualFairs;
        vm.getWebinars                  = getWebinars;
        vm.getEdupoints                 = getEdupoints;
        vm.openInvoicesModal            = openInvoicesModal;
        vm.openEdupointsModal           = openEdupointsModal;
        vm.openInvoicesVirtualFairModal = openInvoicesVirtualFairModal;
        vm.openInvoicesWebinarModal     = openInvoicesWebinarModal;
        vm.openAdminModal               = openAdminModal;
        vm.openEmailAccountModal        = openEmailAccountModal;
        vm.invoices                     = false;
        vm.edupoints                    = false;

        vm.section                      = "";

        /*PAGINATION*/
        vm.pageChanged           = pageChanged;
        vm.setPage               = setPage;
        vm.to                    = [];
        vm.totalItems            = [];
        vm.currentPage           = null;
        vm.itemsPerPage          = [];
        vm.page                  = 1;

        // vm.downloadCSV           = downloadCSV;

        function activate() {
            //vm.selectExhibitors();
        }

        // function selectExhibitors () {
        //     GeneralReportsService.getExhibitors().then(function(response){
        //          vm.exhibitors = response;
        //     }).catch(function(err) {
        //     });
        // }

        function getExhibitors() {
            vm.flag = false;
            vm.alert = false;
            vm.query = {};
            if(typeof vm.client !== 'undefined') {
                vm.query['client'] = vm.client;
            }
            if(vm.page !== null)
                vm.query['page'] = vm.page;

            /* Load variables to CSV */
            //vm.citySelectedCSV  = vm.citySelected.expos_locations_id;
            //vm.expoSelectedCSV  = vm.expoSelected.id;
            GeneralReportsService.getExhibitors(vm.query).then(function(response){
                console.log(response);
                vm.clientHistoryResult = response;
                vm.flag = true;
                vm.invoices              = [];
                vm.physicalFairs         = [];
                vm.virtualFairs          = [];
                vm.webinars              = [];
                vm.edupoints             = [];

                if(vm.clientHistoryResult.length === 0){
                    vm.noResultMessage = 'No History Data has been found!';
                    vm.flag = false;
                    vm.alert = true;
                } else {
                    vm.noResultMessage = '';
                    vm.flag = true;
                    vm.alert = false;
                }
                // vm.totalItems = response.data.total;
                // vm.to         = response.data.to;
                // vm.setPage(response.data.current_page);
                // vm.itemsPerPage = response.data.per_page;
            }).catch(function(err){
            });
        }

        function getInvoices(user_id)
        {
            vm.query = {};
            vm.invoices[user_id] = [];
            vm.physicalFair = [];
            vm.virtualFairs = [];
            vm.webinars = [];
            vm.edupoints = [];
            vm.section = "invoices";
            vm.alertText = "Please wait...";
            vm.query['user_id'] = user_id;
            GeneralReportsService.getInvoices(vm.query).then(function(response){
                vm.invoices[user_id] = response;
                if(response.items.length === 0){
                    vm.alertText = "No invoices found.";
                }
            }).catch(function(err){
            });
        }

        function getPhysicalFairs(user_id)
        {
            vm.query = {};
            vm.invoices = [];
            vm.physicalFairs[user_id] = [];
            vm.virtualFairs = [];
            vm.webinars = [];
            vm.edupoints = [];
            vm.section = "physicalfairs";
            vm.alertText = "Please wait...";
            vm.query['user_id'] = user_id;
            vm.invoices = false;
            GeneralReportsService.getPhysicalFairs(vm.query).then(function(response){
                vm.physicalFairs[user_id] = response;
                if(response.items.length === 0){
                    vm.alertText = "No physical fairs found.";
                }
            }).catch(function(err){
            });
        }

        function getVirtualFairs(user_id)
        {
            vm.query = {};
            vm.invoices = [];
            vm.physicalFairs = [];
            vm.virtualFairs[user_id] = [];
            vm.webinars = [];
            vm.edupoints = [];
            vm.section = "virtualfairs";
            vm.alertText = "Please wait...";
            vm.query['user_id'] = user_id;
            GeneralReportsService.getVirtualFairs(vm.query).then(function(response){
                vm.virtualFairs[user_id] = response;
                if(response.items.length === 0){
                    vm.alertText = "No virtual fairs found.";
                }
            }).catch(function(err){
            });
        }

        function getWebinars(user_id)
        {
            vm.query = {};
            vm.invoices = [];
            vm.physicalFairs = [];
            vm.virtualFairs = [];
            vm.webinars[user_id] = [];
            vm.edupoints = [];
            vm.section = "webinars";
            vm.alertText = "Please wait...";
            vm.query['user_id'] = user_id;
            GeneralReportsService.getWebinars(vm.query).then(function(response){
                vm.webinars[user_id] = response;
                if(response.length === 0){
                    vm.alertText = "No webinars found.";
                }
            }).catch(function(err){
            });
        }

        function getEdupoints(user_id)
        {
            vm.query = {};
            vm.invoices = [];
            vm.physicalFairs = [];
            vm.virtualFairs = [];
            vm.webinars = [];
            vm.edupoints[user_id] = [];
            vm.section = "edupoints";
            vm.alertText = "Please wait...";
            vm.query['user_id'] = user_id;
            GeneralReportsService.getEdupoints(vm.query).then(function(response){
                vm.edupoints[user_id] = response;
                if(response.length === 0){
                    vm.alertText = "No EDUPoints found.";
                }
            }).catch(function(err){
            });
        }

        function openInvoicesModal(user_id,expo_id){
            vm.invoiceItems = vm.physicalFairs[user_id].items[expo_id].invoices;
            $uibModal.open({
                templateUrl: 'templates/general-reports/client-history/invoices.html',
                scope: $scope,
                resolve: {
                    invoices : function () {
                        return vm.invoiceItems;
                    }
                }
            });
        }

        function openInvoicesVirtualFairModal(user_id,expo_id){
            vm.invoiceItems = vm.virtualFairs[user_id].items[expo_id].invoices;
            $uibModal.open({
                templateUrl: 'templates/general-reports/client-history/invoices.html',
                scope: $scope,
                resolve: {
                    invoices : function () {
                        return vm.invoiceItems;
                    }
                }
            });
        }

        function openInvoicesWebinarModal(user_id,webinar_id){
            vm.invoiceItems = vm.webinars[user_id].items[webinar_id].invoices;
            console.log(vm.webinars[user_id]);
            $uibModal.open({
                templateUrl: 'templates/general-reports/client-history/invoices.html',
                scope: $scope,
                resolve: {
                    invoices : function () {
                        return vm.invoiceItems;
                    }
                }
            });
        }

        function openEdupointsModal(user_id){
            vm.edupointItems = vm.edupoints[user_id].items;
            $uibModal.open({
                templateUrl: 'templates/general-reports/client-history/edupoints.html',
                scope: $scope,
                resolve: {
                    edupointItems : function () {
                        return vm.edupointItems;
                    }
                }
            });
        }

        function setPage (pageNo) {
            vm.currentPage = pageNo;
        }

        function pageChanged (pageNo) {
            vm.page = vm.currentPage;
            vm.getByFilter();
        }

        function openAdminModal(client, type) {
            $uibModal.open({
                templateUrl: 'templates/edufindme/findClients/admin/template.modal.html',
                controller: 'AdminEdufindmeController',
                controllerAs:'AdminEdufindme',
                resolve:
                {
                    client      : function () {
                        return client;
                    },
                    type  : function () {
                        return type;
                    },
                }
            });
        }

        function openEmailAccountModal(client) {
            console.log(client)
            $uibModal.open({
                templateUrl: 'templates/general-reports/client-history/email-account/template.modal.html',
                controller: 'EmailAccountController',
                controllerAs:'emailAccount',
                resolve: {
                    client      : function () {
                        return client;
                    },
                }
            });
        }

        activate();
    }
})();